import React, { useState, useEffect, useRef, useCallback } from "react";

const ZoomableChartWrapper = ({ data, children }) => {
  const containerRef = useRef(null);
  const totalItems = data?.length || 0;

  const [viewStart, setViewStart] = useState(0);
  const [viewLength, setViewLength] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [lastMouseX, setLastMouseX] = useState(0);

  // Инициализация окна при загрузке данных
  useEffect(() => {
    setViewStart(0);
    setViewLength(totalItems);
  }, [totalItems]);

  // Зум колесиком мыши
  const handleWheel = useCallback((e) => {
    if (!containerRef.current || totalItems <= 3) return;
    e.preventDefault();
    
    const rect = containerRef.current.getBoundingClientRect();
    const mouseXPercent = (e.clientX - rect.left) / rect.width;

    const zoomFactor = e.deltaY > 0 ? 1.2 : 0.8;
    let newLength = viewLength * zoomFactor;

    if (newLength > totalItems) newLength = totalItems;
    if (newLength < 3) newLength = Math.min(3, totalItems);

    let newStart = viewStart + (viewLength - newLength) * mouseXPercent;
    if (newStart < 0) newStart = 0;
    if (newStart + newLength > totalItems) newStart = totalItems - newLength;

    setViewStart(newStart);
    setViewLength(newLength);
  }, [viewLength, viewStart, totalItems]);

  // Регистрация wheel события как non-passive, чтобы работал preventDefault
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.addEventListener("wheel", handleWheel, { passive: false });
    return () => el.removeEventListener("wheel", handleWheel);
  }, [handleWheel]);

  // Перемещение графика перетаскиванием (Pan)
  const onPointerDown = (e) => {
    if (totalItems <= 3) return;
    setIsDragging(true);
    setLastMouseX(e.clientX);
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e) => {
    if (!isDragging || !containerRef.current || totalItems <= 3) return;
    const rect = containerRef.current.getBoundingClientRect();
    const deltaX = e.clientX - lastMouseX;
    setLastMouseX(e.clientX);

    const deltaItems = -(deltaX / rect.width) * viewLength;
    let newStart = viewStart + deltaItems;

    if (newStart < 0) newStart = 0;
    if (newStart + viewLength > totalItems) newStart = totalItems - viewLength;

    setViewStart(newStart);
  };

  const onPointerUp = (e) => {
    setIsDragging(false);
    e.currentTarget.releasePointerCapture(e.pointerId);
  };

  // Вырезка данных
  let slicedData = data;
  if (totalItems > 0) {
    const startIndex = Math.floor(viewStart);
    const endIndex = Math.ceil(viewStart + viewLength);
    slicedData = data.slice(startIndex, endIndex);
  }

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        cursor: isDragging ? "grabbing" : (totalItems > 3 ? "grab" : "default"),
        touchAction: "none",
        position: "relative",
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
    >
      {totalItems > 5 && (
        <div style={{ position: "absolute", top: 5, right: 5, zIndex: 10, background: "rgba(255,255,255,0.85)", padding: "2px 6px", borderRadius: "4px", fontSize: "10px", color: "#666", pointerEvents: "none" }}>
          Зум: Колесико мыши | Прокрутка: ЛКМ
        </div>
      )}
      {children(slicedData)}
    </div>
  );
};

export default ZoomableChartWrapper;